import "../../design/login.css";
import { useEffect, useState } from 'react';
import axios from "axios";
import { API_URL } from "../../api/API_SERVERS";
import Toast from "../../utils/components/Toast";
import { useNavigate } from "react-router-dom";
import Loading from "../../utils/components/Loading";

export default function Login() {
    const [personID, setPersonID] = useState('');
    const [password, setPassword] = useState('');
    const [toast, setToast] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const showToast = (message, type = "error") => {
        setToast({ message, type });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.post(
                API_URL + '/api/teachers/login',
                { personId: personID, password },
                { headers: { "Content-Type": "application/json" } }
            ).then(res => {
                localStorage.setItem("teacherToken", res.data.token);
                showToast(res.data.message, 'success');
                setTimeout(() => {
                    navigate("/logged-in");
                }, 1500);
            });
        } catch (e) {
            const message = e.response?.data?.message || "დაფიქსირდა შეცდომა";
            showToast(message);
            setLoading(false);
        } finally {
            setPersonID('');
            setPassword('');
        }
    };

    useEffect(() => {
        if (localStorage.getItem("teacherToken")) {
            navigate("/logged-in");
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div className="login-container">
            {loading && <Loading />}
            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(null)}
                />
            )}
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">ავტორიზაცია</h2>

                <div className="login-input-group">
                    <label className="login-input-label">ს/ნ</label>
                    <input
                        type="text"
                        className="login-input-field"
                        placeholder={'მაგ: 01234567890'}
                        value={personID}
                        onChange={(e) => setPersonID(e.target.value)}
                        required
                        autoComplete="off"
                    />
                </div>

                <div className="login-input-group">
                    <label className="login-input-label">პაროლი</label>
                    <input
                        type="password"
                        className="login-input-field"
                        placeholder={'********'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="off"
                    />
                    <p
                        className="login-forgot-password"
                        onClick={() => navigate("/forgot-password")}
                    >
                        დაგავიწყდა პაროლი?
                    </p>
                </div>

                <button type="submit" className="login-submit-button" disabled={loading}>
                    შესვლა
                </button>

                <p className="login-register-prompt">
                    არ გაქვთ ანგარიში?
                    <span onClick={() => navigate("/register")} className="login-register-link">
                        რეგისტრაცია
                    </span>
                </p>
            </form>
        </div>
    );
}